const reasons = [
  {
    icon: 'ri-award-line',
    title: 'Gecertificeerd & Verzekerd',
    description: 'Onze schoonmaakprofessionals zijn volledig gecertificeerd en verzekerd. Uw pand en personeel zijn bij ons in veilige handen.',
  },
  {
    icon: 'ri-leaf-line',
    title: 'Milieuvriendelijk',
    description: 'Wij werken uitsluitend met ecologische schoonmaakmiddelen. Goed voor het milieu, veilig voor uw medewerkers en net zo effectief.',
  },
  {
    icon: 'ri-team-line',
    title: 'Ervaren team',
    description: 'Ons team heeft ruime ervaring met uiteenlopende branches — van kantoren en winkels tot horeca en zorginstellingen.',
  },
  {
    icon: 'ri-price-tag-3-line',
    title: 'Scherpe tarieven',
    description: 'Transparante prijzen zonder verborgen kosten. U weet precies waar u aan toe bent, altijd een eerlijke prijs voor hoogwaardige schoonmaak.',
  },
  {
    icon: 'ri-phone-line',
    title: 'Persoonlijk contact',
    description: 'Een vast aanspreekpunt voor uw locatie. Korte lijnen, heldere afspraken en altijd bereikbaar voor overleg of wijzigingen.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Kwaliteit voorop',
    description: 'Wij werken met vaste kwaliteitscontroles en periodieke evaluaties. Uw tevredenheid is onze hoogste prioriteit.',
  },
];

export default function WhyUsSection() {
  return (
    <section className="relative py-24 md:py-32 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-primary-600 mb-4">
            Waarom A&Z
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-5">
            Kiezen voor{' '}
            <span className="text-primary-500">kwaliteit</span>
          </h2>
          <p className="text-foreground-600 leading-relaxed">
            U wilt dat uw bedrijfspand altijd fris en schoon is — geregeld door professionals die weten wat ze doen. 
            Daarom kiest u voor A&Z Schoonmaakdienst — altijd de juiste keuze.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {reasons.map((reason) => (
            <div key={reason.title} className="flex gap-5 p-6 rounded-2xl hover:bg-background-100 transition-colors duration-200 cursor-default">
              <div className="w-11 h-11 flex-shrink-0 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600">
                <i className={`${reason.icon} text-lg`}></i>
              </div>
              <div>
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">
                  {reason.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {reason.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}